<footer class="footer py-5">
	<div class="container-fluid">
		<div class="row justify-content-between align-items-center flex-column flex-xl-row ">
			<div class="col-auto">
				<span class="text--md text--sm-weight "> © 2020 Vencon Sp. z o. o. </span>
			</div>
			<div class="col-auto d-flex flex-column">
				<span class="text--sm text--sm-weight">info@tott.travel</span>
				<span class="text--sm text--sm-weight">ul. Mazańcowicka 20 </span>
				<span class="text--sm text--sm-weight">43-502 Czechowice-Dziedzice</span>
			</div>
			<div class="col-auto">
				<ul class="d-flex flex-column flex-xl-row ">
					<li class="mr-12">
						<a routerLink="/privacy-policy">Polityka Prywatności</a>
					</li>
					<li class="mr-12">
						<a routerLink="/cookies">Pliki cookies </a>
					</li>
					<li class="mr-12">
						<a routerLink="/regulations">Regulamin</a>
					</li>
					<li class="mr-12">
						<a routerLink="/faq">FAQ</a>
					</li>
				</ul>
			</div>
			<div class="col-auto">
				<a href="https://apps.apple.com/pl/app/together-on-the-trail/id1486082370?l=pl">
					<img class="mr-6"
						src="/assets/images/footer/appstore.svg">
				</a>
				<a href="https://play.google.com/store/apps/details?id=com.fasttrack.app">
					<img src="/assets/images/footer/google-play.svg">
				</a>
			</div>
		</div>
	</div>
</footer>
<!-- <div id="footer"
	class="sticky-footer bg-primary pt-5">

	<div class="container">
		<div class="row">
			<div class="col-md-5 col-sm-6">
				<img class="footer-logo"
					src="assets/images/logo-white.png"
					alt="">
				<br><br>
				<p class="text-white">Morbi convallis bibendum urna ut viverra. Maecenas quis consequat libero, a feugiat eros. Nunc ut lacinia tortor morbi ultricies laoreet ullamcorper phasellus semper.</p>
				<div class="text-widget text-white">
					<span class="text-white">12345 Little Lonsdale St, Melbourne</span> <br> Phone: <span class="text-white">(123) 123-456 </span><br> E-Mail:<span class="text-white"> <a href="#"
							class="text-white">office@example.com</a> </span><br>
				</div>
				<div class="mt-4">
					<a target="_blank"
						href="https://twitter.com/"
						class="btn btn-neutral btn-icon-only btn-round btn-lg"
						data-toggle="tooltip"
						data-original-title="Follow us">
						<i class="fa fa-twitter"></i>
					</a>
					<a target="_blank"
						href="https://www.facebook.com/"
						class="btn btn-neutral btn-icon-only btn-round btn-lg"
						data-toggle="tooltip"
						data-original-title="Like us">
						<i class="fa fa-facebook-square"></i>
					</a>
					<a target="_blank"
						href="https://dribbble.com/"
						class="btn btn-neutral btn-icon-only  btn-lg btn-round"
						data-toggle="tooltip"
						data-original-title="Follow us">
						<i class="fa fa-dribbble"></i>
					</a>
					<a target="_blank"
						href="https://github.com/"
						class="btn btn-neutral btn-icon-only btn-round btn-lg"
						data-toggle="tooltip"
						data-original-title="Star on Github">
						<i class="fa fa-github"></i>
					</a>
				</div>
			</div>
			<div class="col-md-4 col-sm-6 ">
				<ul class="footer-links">
					<li><a class="text-white"
							routerLink='/session/login'>Login</a></li>
					<li><a class="text-white"
							routerLink='/session/signup'>Sign Up</a></li>
					<li><a class="text-white"
							routerLink='/session/forgot-password'>Forgot Password</a></li>
					<li><a class="text-white"
							routerLink='/pages/add-listing'>Add Listing</a></li>
					<li><a class="text-white"
							routerLink='/pages/pricing'>Pricing</a></li>
					<li><a class="text-white"
							routerLink='/pages/about-us'>About</a></li>
				</ul>
			</div>
			<div class="col-md-3  col-sm-12">
				<ul class="footer-links">
					<li><a class="text-white"
							routerLink='/pages/user-profile'>Profile</a></li>
					<li><a class="text-white"
							routerLink='/pages/blog/list'>Blog</a></li>
					<li><a class="text-white"
							routerLink='/pages/invoice'>Invoice</a></li>
					<li><a class="text-white"
							routerLink='/pages/booking'>Booking</a></li>
					<li><a class="text-white"
							routerLink='/pages/contact-us'>Contact</a></li>
				</ul>
			</div>
		</div>
		<div class="row">
			<div class="col-md-12">
				<div class="copyrights text-white">© 2019 DirectList. All Rights Reserved.</div>
			</div>
		</div>
	</div>
</div> -->
